import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import National from '../DashboardTabs/National';
import Regions from '../DashboardTabs/Regions';
import DivisionalSpecifics from '../DashboardTabs/DivisionalSpecifics';
import { CustomDashboard } from '..';
import { useContext, useEffect, useState } from 'react';
import DashboardContext from "../../../contexts/DashboardContext";
import Maps from '../DashboardTabs/Maps';
import { MapsProvider } from '../../../contexts/MapsContext';
import { RolesContext } from '../../../contexts/RolesContext';

const NavTabSection = () => {
  const [tabIndex, setTabIndex] = useState(Number(localStorage.getItem('dashboardTabLastSelected')) || 0)
  const { regionListForCM, isLoadingRegionListForCM, setDashboardTabIndex } = useContext(DashboardContext)
  const permCheck = useContext(RolesContext).userHasPermission;
  const userCanAccessRegions = permCheck('all', 'Regions');
  const userCanAccessNational = permCheck('all', 'National');
  const userCanAccessDivisionOverview = permCheck('all', 'Division Overview');
  const userCanAccessDivisionalWidgets = permCheck('all', 'Divisional Widgets');
  const userCanAccessMap = permCheck('all', 'Map');

  let tabNames = ['National', 'Regions', 'Division Overview', 'Divisional Widgets', 'Map']

  // National and Regions break their figures down per region, so they have
  // nothing to show a tenant that has not created any.
  const tenantHasRegions = Array.isArray(regionListForCM) && regionListForCM.length > 0

  // Single source of truth for "can this tab be reached", indexed like tabNames
  // and the TabPanels below. Rendering and selection both read it, so a tab can
  // no longer be hidden and selected at the same time (SW2-2290).
  const tabIsVisible = [
    userCanAccessNational && tenantHasRegions,
    userCanAccessRegions && tenantHasRegions,
    userCanAccessDivisionOverview,
    userCanAccessDivisionalWidgets,
    userCanAccessMap,
  ]

  const handleTabSelection = (index:any) => {
    localStorage.setItem('dashboardTabLastSelected', index)
    setTabIndex(index)
    setDashboardTabIndex(index)
  }

  useEffect (() => {
    // The region list is empty both while it is loading and when the tenant has
    // none. Deciding during the former would throw a tenant that does have
    // regions off National on every load, so wait until it has settled.
    if (isLoadingRegionListForCM) return
    if (tabIsVisible[tabIndex]) return

    const firstVisibleTab = tabIsVisible.findIndex(Boolean)

    if (firstVisibleTab === -1 || firstVisibleTab === tabIndex) return

    // Via handleTabSelection rather than setTabIndex: the tab data hooks in
    // src/hooks/customDashboard.ts read the active tab from localStorage, so a
    // redirect that skipped it would land on a tab that never fetches.
    handleTabSelection(firstVisibleTab)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    tabIndex,
    tenantHasRegions,
    isLoadingRegionListForCM,
    userCanAccessNational,
    userCanAccessRegions,
    userCanAccessDivisionOverview,
    userCanAccessDivisionalWidgets,
    userCanAccessMap,
  ])

  const tabList = () => {
    return tabNames.map((ele, index) => (
      <Tab key={ele} style={{ display: tabIsVisible[index] ? 'inline-block' : 'none' }}>{ele}</Tab>
    ))
  }
  
  return (
    <div className='nav-tab-section'>
      <Tabs selectedIndex={tabIndex} onSelect={handleTabSelection}>
        <TabList>
          <div className='nav-tab-section__tablist-inner-container'>
            <div className='nav-tab-section__tab-wrapper'>
              {tabList()}
            </div>
          </div>
        </TabList>

        <TabPanel>
          <National setTabIndex={setTabIndex}/>
        </TabPanel>
        
        <TabPanel style={{ display: (Array.isArray(regionListForCM) && regionListForCM.length) ? 'block' : 'none' }}>
          <Regions setTabIndex={setTabIndex} setDashboardTabIndex={setDashboardTabIndex}/>
        </TabPanel>

        <TabPanel>
          <DivisionalSpecifics setTabIndex={setTabIndex}/>
        </TabPanel>

        <TabPanel>
          <CustomDashboard />
        </TabPanel>

        <TabPanel>
          <MapsProvider>
            <Maps />
          </MapsProvider>
        </TabPanel>
      </Tabs>
    </div>
  )
}

export default NavTabSection